// İnternet yokken: cihazdaki onaylı talepler salt okunur gösterilir
import { useEffect, useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { WifiOff, Eye, Search, Users, Truck } from 'lucide-react';
import { loadOffline } from '../../lib/offline';
import { formatDate, getActualStatus } from './constants';
import WorkPermitDetailDialog from './WorkPermitDetailDialog';
import { OfflineTodayOnSite } from './OfflineTodayOnSite';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';

const matches = (it, t) => !t || [it.permit.request_number, it.company_name, it.location_name, it.permit.job_description,
  ...it.employees.map(e => `${e.name} ${e.surname} ${e.tc_kimlik_no || ''}`)].join(' ').toLocaleLowerCase('tr').includes(t);

export const OfflinePermitsView = ({ userId }) => {
  const [data, setData] = useState(undefined);
  const [q, setQ] = useState('');
  const [view, setView] = useState(null);
  useEffect(() => { loadOffline('approved-permits').then(d => setData(d && d.user_id === userId ? d : null)); }, [userId]);
  const items = (data?.items || []).filter(it => getActualStatus(it.permit) === 'aktif');
  const shown = items.filter(it => matches(it, q.trim().toLocaleLowerCase('tr')));
  return (
    <div className="space-y-5" data-testid="offline-permits-view">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><WifiOff className="h-6 w-6 text-amber-600" />Çalışma İzinleri <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">Çevrimdışı</Badge></h1>
        <p className="text-slate-500 mt-1">Cihazınıza kaydedilmiş onaylı talepler gösteriliyor. İnternet gelene kadar yeni işlem veya değişiklik yapılamaz.
          {data?.saved_at && <span className="text-slate-700" data-testid="offline-saved-at"> Son güncelleme: {new Date(data.saved_at).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' })}</span>}</p>
      </div>
      <Tabs defaultValue="list">
      <TabsList className="mb-4">
        <TabsTrigger value="list" data-testid="offline-tab-list">Onaylı Talepler ({items.length})</TabsTrigger>
        <TabsTrigger value="today" data-testid="offline-tab-today">Bugün Sahada</TabsTrigger>
      </TabsList>
      <TabsContent value="today"><OfflineTodayOnSite items={items} onView={setView} /></TabsContent>
      <TabsContent value="list" className="space-y-5">
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input className="pl-9" placeholder="Talep no, firma, personel adı veya TC ara..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="offline-search-input" />
      </div>
      {data === undefined ? <p className="text-slate-400">Yükleniyor...</p>
        : shown.length === 0 ? <Card className="border-dashed"><CardContent className="p-10 text-center text-slate-500" data-testid="offline-empty">{items.length ? 'Aramanıza uygun talep yok.' : 'Cihazda kayıtlı onaylı talep yok. İnternet varken Çalışma İzinleri sayfasını açtığınızda onaylı talepler otomatik kaydedilir.'}</CardContent></Card>
          : <div className="space-y-2">{shown.map(it => (
            <Card key={it.permit.id} className="border-slate-200" data-testid={`offline-permit-${it.permit.id}`}>
              <CardContent className="flex flex-wrap items-center gap-x-6 gap-y-2 p-4">
                <span className="font-mono text-sm font-semibold text-slate-900 w-28">{it.permit.request_number || '-'}</span>
                <span className="min-w-0 flex-1"><span className="block truncate font-medium text-slate-800">{it.company_name}</span><span className="block truncate text-xs text-slate-500">{it.location_name} · {it.permit.job_description}</span></span>
                <span className="text-sm text-slate-600">{formatDate(it.permit.start_date)} – {formatDate(it.permit.end_date)}<span className="block text-xs text-slate-400">{it.permit.start_time || '-'} - {it.permit.end_time || '-'}</span></span>
                <span className="flex items-center gap-3 text-sm text-slate-600"><span className="flex items-center gap-1"><Users className="h-4 w-4" />{it.employees.length}</span><span className="flex items-center gap-1"><Truck className="h-4 w-4" />{it.equipment.length}</span></span>
                <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100">Onaylandı</Badge>
                <Button size="sm" variant="outline" onClick={() => setView(it)} data-testid={`offline-view-${it.permit.id}`}><Eye className="h-4 w-4 mr-1" />Detay</Button>
              </CardContent>
            </Card>
          ))}</div>}
      </TabsContent>
      </Tabs>
      <WorkPermitDetailDialog open={!!view} onOpenChange={(o) => !o && setView(null)} permit={view?.permit} offline
        getLocationName={() => view?.location_name} getCompanyName={() => view?.company_name}
        allEmployees={view?.employees || []} allEquipment={view?.equipment || []} company={view?.company} />
    </div>
  );
};
